 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; } var _class;
import React, {Component,} from 'react'
import {PALETTE} from '../../styles/paletteV3'

const baseStyle = {
  color: PALETTE.SLATE_700
}








const EditorLink = (getEditorState) => (_class =
  class InnerEditorLink extends Component {constructor(...args) { super(...args); _class.prototype.__init.call(this);_class.prototype.__init2.call(this);_class.prototype.__init3.call(this); }
    __init() {this.state = {hasFocus: false}}

    __init2() {this.onClick = (e) => {
      const hasFocus = _optionalChain([getEditorState, 'call', _11 => _11(), 'optionalAccess', _12 => _12.getSelection, 'call', _13 => _13(), 'optionalAccess', _14 => _14.getHasFocus, 'call', _15 => _15()])
      if (hasFocus) return
      e.preventDefault()
      const {contentState, entityKey} = this.props
      const {href} = contentState.getEntity(entityKey).getData()
      window.open(href, '_blank', 'noreferrer')
    }}

    __init3() {this.onMouseOver = () => {
      const hasFocus = _optionalChain([getEditorState, 'call', _16 => _16(), 'optionalAccess', _17 => _17.getSelection, 'call', _18 => _18(), 'optionalAccess', _19 => _19.getHasFocus, 'call', _20 => _20()])
      if (this.state.hasFocus !== hasFocus) {
        this.setState({hasFocus})
      }
    }}

    render() {
      const {offsetkey, children} = this.props
      const {hasFocus} = this.state
      const style = {
        ...baseStyle,
        cursor: hasFocus ? 'text' : 'pointer',
        textDecoration: 'underline'
      }
      return (
        React.createElement('span', {
          'data-offset-key': offsetkey,
          style: style,
          onMouseOver: this.onMouseOver,
          onMouseDown: this.onClick,}

          , children
        )
      )
    }
  }, _class)

export default EditorLink
